import { render } from "./EditStaff.vue?vue&type=template&id=11ac1bc6&scoped=true"
import script from "./EditStaff.vue?vue&type=script&lang=js"
export * from "./EditStaff.vue?vue&type=script&lang=js"

import "./EditStaff.vue?vue&type=style&index=0&id=11ac1bc6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11ac1bc6"]])

export default __exports__